/*
 * Dynamically import all .js files
 * */

import * as views from "../views/**/*.js";
import * as utils from "./js/*.js";
